import { createSelector } from '@reduxjs/toolkit';

const getNotifications = state => state?.notifications;

export const selectNotificationTypesToListenTo = createSelector(
  getNotifications,
  state => state?.notificationTypesToListenTo
);
